import { useCallback } from "react";
import { useForm } from "react-hook-form";

import { TagPickerProps, ManageTagsFormState } from "../types";

export const TagInput = ({
  onAddTag,
  inputRef,
  commonTags,
  recentTags,
  selectedTags,
  tenantId,
  TagPickerComponent,
}: {
  onAddTag: (tag: string) => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
  commonTags: string[];
  recentTags: string[];
  selectedTags: string[];
  tenantId?: string;
  TagPickerComponent: React.ComponentType<TagPickerProps>;
}) => {
  const form = useForm<ManageTagsFormState>({
    defaultValues: { tagInput: "" },
  });

  const handleAddTag = useCallback(
    (tag: string) => {
      onAddTag(tag);
      form.setValue("tagInput", "");
      // Refocus the input
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    },
    [onAddTag, form, inputRef]
  );

  return (
    <TagPickerComponent
      onAddTag={handleAddTag}
      inputRef={inputRef}
      commonTags={commonTags}
      recentTags={recentTags}
      selectedTags={selectedTags}
      {...(tenantId && { tenantId })}
    />
  );
};
